<div class="login-top-bar">
  <div class="login-logo">
    <img src="../../assets/img/Logo_bianco.png" alt="Logo" />
  </div>
  <div class="background-logo">
    <img src="../../assets/img/sfondo_frecce.png" alt="Background-logo" class="mt-4 side-logo" />
  </div>
</div>
<div class="login-container">
  <div class="row w-100 h-100 text-center d-flex justify-content-center">
    <div class="col-12 text-center input-container">
      <div class="d-flex flex-column justify-content-between h-100">
        <div class="">
          <h2 class="login-title mt-4">
            {{ 'NEW_PASSWORD.TITLE' | translate }}
          </h2>
          <p class="forgot-password-subtitle">
            {{ 'NEW_PASSWORD.SUBTITLE' | translate }}
          </p>
          @if (!isReady) {
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status"></div>
            </div>
          } @else {
            <form [formGroup]="form" class="forgot-password-form mt-5" (ngSubmit)="handleResetPassword()">
              <app-icam-input
                label="{{ 'NEW_PASSWORD.PASSWORD' | translate }}"
                inputId="password"
                inputType="password"
                [required]="true"
                formControlName="password"
                />
              <app-icam-input
                label="{{ 'NEW_PASSWORD.PASSWORD_CONFIRM' | translate }}"
                inputId="password"
                inputType="password"
                [required]="true"
                formControlName="confirmPassword"
                />
              @if (passwordFormField?.value) {
                <div class="text-accent-red text-sm text-start">
                  <ul>
                    <li
                      class="block"
                    [ngClass]="{
                      'text-primary': passwordFormField?.value?.match('^(?=.*[A-Z])')
                    }"
                      >
                      {{ 'NEW_PASSWORD.CRITERIA.UPPERCASE' | translate }}
                    </li>
                    <li
                      class="block"
                    [ngClass]="{
                      'text-primary': passwordFormField?.value?.match('(?=.*[a-z])')
                    }"
                      >
                      {{ 'NEW_PASSWORD.CRITERIA.LOWERCASE' | translate }}
                    </li>
                    <li
                      class="block"
                    [ngClass]="{
                      'text-primary': passwordFormField?.value?.match('(?=.*[!@#$%^&*])')
                    }"
                      >
                      {{ 'NEW_PASSWORD.CRITERIA.SPECIAL' | translate }}
                    </li>
                    <li
                      class="block"
                    [ngClass]="{
                      'text-primary': passwordFormField?.value?.match('.{8,}')
                    }"
                      >
                      {{ 'NEW_PASSWORD.CRITERIA.LENGTH' | translate }}
                    </li>
                  </ul>
                </div>
              }
              @if (form.errors?.['PasswordNoMatch']) {
                <div class="text-accent-red text-start">
                  {{ 'NEW_PASSWORD.NO_MATCH' | translate }}
                </div>
              }
              <button
                type="submit"
                class="mt-5 button-form-submit"
                [class.disabled]="!form.valid"
                [disabled]="!form.valid"
                >
                {{ 'NEW_PASSWORD.SEND' | translate }}
              </button>
            </form>
          }
        </div>
        <div class="mt-5">
          <div class="login-footer justify-content-center">
            <div class="pb-3" id="icamRights">
              <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
